export interface PermissionModel {
  itemName: string;
  items?: PermissionModel[];
}
